import React, { useState } from 'react';
import { useAuth } from '../AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import { LogIn, LogOut, User, Home, Mail } from 'lucide-react';
import logo from '../assets/images/logo-chef.png';

const MiCuenta = () => {
    const { login, user, userData, logout, supabase } = useAuth();
    const navigate = useNavigate();
    
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [resetMessage, setResetMessage] = useState('');
    
    const handleLogin = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setError('');
        setResetMessage('');
        
        const { error } = await login(email, password);
        if (error) {
            setError('Credenciales incorrectas. Intenta de nuevo.');
        } else {
            navigate('/portal/resumen');
        }
        setIsSubmitting(false);
    };

    const handlePasswordReset = async () => {
        setIsSubmitting(true);
        setError('');
        setResetMessage('');

        if (!email) {
            setError('Por favor, ingresa tu correo electrónico para restablecer la contraseña.');
            setIsSubmitting(false);
            return;
        }

        const { error } = await supabase.auth.resetPasswordForEmail(email, {
            redirectTo: 'https://www.banquetesdelchef.com/actualizar-contrasena',
        });

        if (error) {
            setError('No pudimos enviar el correo de recuperación. Por favor, verifica tu email e intenta de nuevo.');
            console.error('Password reset error:', error);
        } else {
            setResetMessage('Se ha enviado un correo electrónico de recuperación. ¡Revisa tu bandeja de entrada!');
        }

        setIsSubmitting(false);
    };

    if (user) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-100">
                <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow-md text-center">
                    
                    {/* --- LOGO AÑADIDO --- */}
                    <Link to="/" className="inline-block mb-4">
                        <img src={logo} alt="Banquetes del Chef" className="mx-auto h-16 w-auto"/>
                    </Link>
                    
                    <User className="mx-auto text-orange-500" size={48} />
                    <h2 className="text-2xl font-bold">Ya has iniciado sesión</h2>
                    <p className="text-gray-600">
                        Hola, <span className="font-semibold">{userData?.first_name || user.email}</span>.
                    </p>
                    <div className="space-y-4 pt-4">
                        <Link to="/portal/resumen" className="w-full flex items-center justify-center px-4 py-2 text-white bg-orange-500 rounded-md hover:bg-orange-600">
                            <Home className="mr-2" size={20} />
                            Ir a Mi Portal
                        </Link>
                        <button 
                            onClick={logout} 
                            className="w-full flex items-center justify-center px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
                        >
                            <LogOut className="mr-2" size={20} />
                            Cerrar Sesión
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
            <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow-md">
                
                {/* --- LOGO AÑADIDO --- */}
                <Link to="/" className="inline-block text-center w-full">
                    <img src={logo} alt="Banquetes del Chef" className="mx-auto h-16 w-auto mb-6"/>
                </Link>

                <h2 className="text-2xl font-bold text-center">Iniciar Sesión</h2>
                <form onSubmit={handleLogin} className="space-y-6">
                    <div>
                        <label htmlFor="email" className="text-sm font-medium">Correo Electrónico</label>
                        <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full px-3 py-2 mt-1 border rounded-md focus:ring-orange-500 focus:border-orange-500" />
                    </div>
                    <div>
                        <label htmlFor="password" className="text-sm font-medium">Contraseña</label>
                        <input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="w-full px-3 py-2 mt-1 border rounded-md focus:ring-orange-500 focus:border-orange-500" />
                    </div>
                    {error && <p className="text-sm text-center text-red-600">{error}</p>}
                    {resetMessage && <p className="text-sm text-center text-green-600">{resetMessage}</p>}
                    <div>
                        <button type="submit" disabled={isSubmitting} className="w-full px-4 py-2 text-white bg-orange-500 rounded-md hover:bg-orange-600 disabled:bg-orange-300 flex items-center justify-center">
                            <LogIn className="mr-2" size={20} />
                            {isSubmitting ? 'Ingresando...' : 'Ingresar'}
                        </button>
                    </div>
                </form>

                <div className="flex justify-center pt-2">
                    <button 
                        type="button" 
                        onClick={handlePasswordReset} 
                        disabled={isSubmitting}
                        className="text-sm text-orange-600 hover:text-orange-500 disabled:opacity-50 flex items-center gap-1"
                    >
                        <Mail size={16} />
                        ¿Olvidaste tu contraseña?
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MiCuenta;